import DatePicker from "react-datepicker";
import LocationAutoComplete from "../../../AutoComplete/AutoComplete";
import TruckSelector from "../TruckSelector/TruckSelector";
import styles from "./RptBody.module.css";

export default function ManualInputForm({
  origin,
  setOrigin,
  destination,
  setDestination,
  truckType,
  setTruckType,
  dateRange,
  setDateRange,
  inputMode,
  validationError = {},
}) {
  const [startDate, endDate] = dateRange;

  const handleClearOrigin = () => setOrigin({});
  const handleClearDestination = () => setDestination({});

  return (
    <div className={styles.formContainer}>
      <div className={styles.formRow}>
        <label>Origin</label>
        <LocationAutoComplete
          value={origin}
          onChange={setOrigin}
          onClear={handleClearOrigin}
          placeholder="Search Location..."
          menuHeight={200}
          fontSize={13}
          showDropdownIcon={true}
          disabled={inputMode === "upload"}
          className={`${validationError.origin ? styles.errorField : ""}`}
        />
        {validationError.origin && Object.keys(origin).length < 1 && (
          <div className={styles.errorMessage}>Origin is required</div>
        )}
      </div>
      <div className={styles.formRow}>
        <label>Destination</label>
        <LocationAutoComplete
          value={destination}
          onChange={setDestination}
          onClear={handleClearDestination}
          placeholder="Search Location..."
          menuHeight={200}
          fontSize={13}
          showDropdownIcon={true}
          disabled={inputMode === "upload"}
          className={`${validationError.destination ? styles.errorField : ""}`}
        />
        {validationError.destination && Object.keys(destination).length < 1 && (
          <div className={styles.errorMessage}>Destination is required</div>
        )}
      </div>
      <div className={styles.formRow}>
        <label>Truck Type</label>
        <TruckSelector
          truckType={truckType}
          setTruckType={setTruckType}
          inlineDimensions={false}
          className={`${validationError.truckType ? styles.errorField : ""}`}
        />
        {validationError.truckType && truckType?.raw_truck_name?.length < 1 && (
          <div className={styles.errorMessage}>Truck type is required</div>
        )}
      </div>
      <div className={styles.formRow}>
        <label>Date</label>
        <DatePicker
          selectsRange
          startDate={startDate}
          endDate={endDate}
          onChange={(update) => setDateRange(update)}
          className={`${styles.datePicker} ${
            validationError.date ? styles.errorField : ""
          }`}
          dateFormat="dd-MM-yyyy"
        />
        {validationError.date && (!startDate || !endDate) && (
          <div className={styles.errorMessage}>Date is required</div>
        )}
      </div>
    </div>
  );
}
